import React from 'react';
import { disclaimer, footerLinks } from '../data/content';
export function Footer() {
  return <footer className="bg-petrol-deep py-14 text-center text-cream/70" data-id="element-91" data-mp="3gfsoqi9xf4pm">
      <div className="mx-auto max-w-[880px] px-5 sm:px-8" data-id="element-92" data-mp="32nukolv2nz0b">
        <p className="text-sm font-semibold uppercase tracking-[0.2em] text-terra-soft" data-id="element-93" data-mp="32pfeg99kbdx4">Megapack Maestro de Sesiones™</p>
        <p className="mt-3 text-sm" data-id="element-94" data-mp="36nd6djupwe47">© 2026 — Todos los derechos reservados</p>
        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm" data-id="element-95" data-mp="3ufjww2drhqvp">
          {footerLinks.map(l => <li key={l} data-id="element-96" data-mp="36mrsgl2ksqw">
              <a href="#" className="transition-colors duration-150 ease-out hover:text-paper" data-id="element-97" data-mp="3lem0a55nkln5">
                {l}
              </a>
            </li>)}
        </ul>
        <div className="mt-8 border-t border-petrol-line pt-8" data-id="element-98" data-mp="3qfjey7rgexjw">
          <p className="text-xs leading-relaxed text-cream/60" data-id="element-99" data-mp="29ydwk0ehj49w">{disclaimer}</p>
        </div>
      </div>
    </footer>;
}